module.exports = __webpack_public_path__ + "img/vk-w.fafdefc8.svg";